<template>
  <div class="area-panel d-flex flex-row w-100 mb-1">
    <div>
      <img :src="area.icon" />
    </div>
    <div class="d-flex flex-column ml-3 w-100">
      <div class="area-title">{{ area.title }}</div>
      <div class="area-text">{{ area.subTitle }}</div>
      <div class="d-flex flex-row sdg-list">
        <img
          :src="sdg.icon"
          v-for="sdg in area.sdg"
          v-bind:key="sdg.id"
          :key="sdg.id"
          class="d-block mr-1 mt-2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getSvgAreaClasses } from "../utils/generic.utils";
export default {
  name: "AreaPanel",
  props: {
    area: Object,
    svg: String
  },
  methods: {
    getSvgAreaClasses(cssClass) {
      const result = [];
      let className = "";

      className = `svg-area-${cssClass}`;

      result.push(className);
      return result;
    }
  }
};
</script>

<style scoped></style>
